module.exports = __webpack_public_path__ + "static/media/icon_up.75c7c3fe.svg";